/* eslint-disable @typescript-eslint/camelcase */
import RenderInfo from 'components/RenderInfo';
import React from 'react';
import { DEFAULT_PLACEHOLDER } from 'utils';
import styles from './index.module.scss';

const BasicDetails = (props) => {
  const { details: { name = '', description = '', objectId = '',createdAt='', user:{ objectId: userId = '',username='',email='',phone='',full_name='' }={} ,
    image: { url: imageUrl = DEFAULT_PLACEHOLDER } = {}} = {}} = props;

  
  return <div className={styles['details-section']}>
    <img src={imageUrl} className={styles['product-image']} />
    <div className={styles['info-container']}>
      <div className={styles['info']}>
        <RenderInfo heading="ID" value={objectId} />
        <RenderInfo heading="Name" value={name} />
        <RenderInfo heading="Description" value={description} />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="User" value={userId} link={`/users/${userId}`}/>
        <RenderInfo heading="User Name" value={username}/>
        <RenderInfo heading="Email" value={email}/>
        <RenderInfo heading="Phone" value={phone}/>
        <RenderInfo heading="Full Name" value={full_name}/>
        <RenderInfo heading="Created At" value={createdAt} type='date' />
      </div>
    </div>
  </div>;
};

export default BasicDetails;